import { Injector } from '@angular/core';
import { PaginationGet, User } from '@api/types';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { TableDataSource } from '@shared/table/table.datasource';
import { finalize } from 'rxjs/operators';

export class UsersGridDataSource extends TableDataSource {
  private localStorage: LocalStorageService;
  constructor(injector: Injector) {
    super(injector);
    this.localStorage = injector.get(LocalStorageService);
  }

  loadData(params: any): void {
    this.onLoadDataStart();
    this.api.accounts.byId.users
      .get(this.localStorage.userWithToken.account_id, params)
      .pipe(finalize(() => this.onLoadDataEnd()))
      .subscribe((paginatedGetUsers: PaginationGet<User>) => {
        const data = paginatedGetUsers.data.map((user) => ({
          ...user,
          enable_2fa: user.enable_2fa ? 'Enabled' : 'Disabled'
        }));
        this.paginatedGet.next({ ...paginatedGetUsers, data });
      });
  }
}
